import { withLocalState } from 'pyradux';

import TradesContainer from './Trades.container';
import reducer from './Trades.reducer';
import TradesSagas from './Trades.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'trades',
  sagas: [TradesSagas],
};

export default withLocalState(withLocalStateOptions, TradesContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/index.js